import React from 'react';
import { displayMessage } from './wsHelpers';
import SubscriptionTemplate from './SubscriptionTemplate';
import {
	addEvent,
	updateEvent,
	deleteEvent,
	undeleteEvent,
	updateClient,
	deleteAttendee,
	setAdmin,
} from '@/redux/actions';
import { connect } from 'react-redux';

const SOCKET_EVENTS_BY_HTTP = {
	EVENT_PATCH: 'event/:eventID/PATCH',
	EVENT_DELETE: 'event/:eventID/DELETE',
	EVENT_POST: 'event/POST',
	EVENT_UNDELETE: 'event/:eventID/undelete/PATCH',
	CLIENT_PATCH: 'client/:clientID/PATCH',
	DELETE_ATTENDEE: 'attendee/:attendeeID/DELETE',
};

const ClientSubscriptions = props => {
	const {
		socket,
		currentClient,
		addEvent,
		updateEvent,
		undeleteEvent,
		deleteEvent,
		deleteAttendee,
		updateAdmin,
		admins,
		adminSSOProfile,
		route,
		children,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToClient = () => {
		socket.emit('client/:clientID/SUBSCRIBE', { clientID: currentClient.id });
		if (adminSSOProfile) {
			socket.emit('admin/:adminEmail/SUBSCRIBE', { email: adminSSOProfile.email });
		}
		console.log('⚡️ ClientSubscriptions Mounted ⚡️');
	};

	const unsubscribeToClient = () => {
		socket.emit('client/:clientID/UNSUBSCRIBE', { clientID: currentClient.id });
		if (adminSSOProfile) {
			socket.emit('admin/:adminEmail/UNSUBSCRIBE', { email: adminSSOProfile.email });
		}
		console.log(`🚶‍♂️ ClientSubscriptions Unmounted 🚶‍♂️`);
	};

	const addEventToAdmin = event => {
		let updatedAdmin = admins[adminSSOProfile.email];
		if (updatedAdmin && updatedAdmin.events) {
			updatedAdmin.events.push(event);
			updateAdmin(updatedAdmin, adminSSOProfile.email);
		}
	};

	const removeEventFromAdmin = event => {
		let updatedAdmin = admins[adminSSOProfile.email];
		if (updatedAdmin && updatedAdmin.events) {
			updatedAdmin.events = updatedAdmin.events.filter(evt => evt.id !== event.id);
			updateAdmin(updatedAdmin, adminSSOProfile.email);
		}
	};

	const listenForCreatedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_POST, payload => {
			const { data, error } = payload;
			if (error) {
				if (error.response && error.response.errors && error.response.errors.length > 0) {
					const firstError = error.response.errors[0] || {};
					const err = firstError.message;
					if (err.includes('more than')) {
						displayMessage('You cannot create more than two unpaid events', err);
					} else {
						displayMessage('Event could not be created', err);
					}
				} else {
					displayMessage('Event could not be created', error);
				}
			} else {
				addEventToAdmin(data);
				addEvent(data);
				displayMessage('Event created');
			}
		});

	const listenForUpdatedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_PATCH, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event could not be updated', error);
			else {
				updateEvent(data);
				displayMessage('Event updated');
			}
		});

	const listenForUndeletedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_UNDELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event could not be unarchived', error);
			else {
				undeleteEvent(data);
				displayMessage('Event unarchived');
			}
		});

	const listenForDeletedEvent = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.EVENT_DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event could not be deleted', error);
			else {
				removeEventFromAdmin(data);
				deleteEvent(data);
				displayMessage('Event Archived');
			}
		});

	const listenForUpdatedClient = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.CLIENT_PATCH, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Client could not be updated', error);
			else {
				updateClient(data);
				displayMessage('Client updated');
			}
		});

	const listenForDeletedAttendee = () => {
		socket.on(SOCKET_EVENTS_BY_HTTP.DELETE_ATTENDEE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Account could not be deleted', error);
			else {
				deleteAttendee({ attendeeID: data.id });
				displayMessage('Account deleted');
			}
		});
	};
	const listeners = () =>
		route === '/events/'
			? [
					listenForCreatedEvent,
					listenForUpdatedEvent,
					listenForDeletedEvent,
					listenForUndeletedEvent,
					listenForUpdatedClient,
			  ]
			: route === '/accounts/'
			? [listenForDeletedAttendee]
			: [listenForUpdatedClient];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToClient}
				unsub={unsubscribeToClient}
				listeners={listeners()}
				routes={Object.values(SOCKET_EVENTS_BY_HTTP)}
				from="client"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ auth, ws, clients, admins }) => ({
	adminSSOProfile: auth.adminSSOProfile,
	socket: ws.socket,
	currentClient: clients.currentClient,
	admins,
});

const mdp = dispatch => ({
	addEvent: event => dispatch(addEvent(event)),
	updateEvent: event => dispatch(updateEvent(event)),
	deleteEvent: event => dispatch(deleteEvent(event)),
	undeleteEvent: event => dispatch(undeleteEvent(event)),
	updateClient: client => dispatch(updateClient(client)),
	deleteAttendee: attendeeID => dispatch(deleteAttendee(attendeeID)),
	updateAdmin: (admin, email) => dispatch(setAdmin(admin, email)),
});

export default connect(msp, mdp)(ClientSubscriptions);
